import { Box, styled, Theme, Typography } from '@mui/material';

export const ChatMessagesFooter = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    maxHeight: '130px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 32px 32px 32px',
    borderTop: '1px solid #D8DBE8',

    [theme.breakpoints.down('tablet')]: {
      padding: '24px 16px',
    },

    '> form': {
      width: '100%',
    },
  };
});

export const ChatMessagesFooterNonActiveText = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    color: '#A9A9A9',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '136%',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  };
});
